import React from "react";
import { TiChevronRight } from "react-icons/ti";

const categoryList = [
  "Catch and shoot 3 point",
  "Off the dribble 3 point",
  "right",
  "left",
  "assisted plays",
  "self created plays",
  "transition",
  "midrange",
  "half court",
  "assisted plays",
  "self created",
  "off screen 3",
  "catch and shoot 3",
  "driving to the basket",
  "perimeter drive to the basket",
  "pulling up from 3",
  "drive to basket",
  "off the dribble long midrange",
  "P&R",
  "offensive shot",
  "roll to the basket",
];

const getPercentage = (sentence = "") => {
  const percent = sentence.match(/\d{1,}%/gi);

  if (percent.length > 0) {
    return percent[0].replace("%", "");
  } else {
    return "N/A";
  }
};

const getCategory = (sentence = "", categoryType = "most") => {
  const text = categoryType === "most" ? sentence.match(/.+than/gi)?.[0] : sentence.match(/than.+/gi)?.[0];

  const filteredCat = categoryList.filter((cat) => {
    if (text) {
      return text.toLowerCase().match(cat.toLowerCase());
    } else {
      return false;
    }
  });

  if (filteredCat.length > 0) {
    return filteredCat[0];
  } else {
    return "";
  }
};

const getPlayer = (sentence, playerList, categoryType = "most") => {
  const text = categoryType === "most" ? sentence.match(/.+than/gi)?.[0] : sentence.match(/than.+/gi)?.[0];

  const filteredPlayerName = playerList.filter((player) => text.toLowerCase().includes(player.toLowerCase()));

  if (filteredPlayerName.length > 0) {
    return filteredPlayerName[0];
  } else {
    return "";
  }
};

function createMarkup(text) {
  return { __html: text };
}

const getFormattedText = (sentence = "") => {
  return sentence
    .replace(/(still run \d{1,} times)/gi, `<strong>$1</strong>`)
    .replace(/(\d{1,3}% (more|less) efficient)/gi, `<strong>$1</strong>`);
};

const SQDocCard = ({ sentence = "", teamPlayers = [], displayType = "player" }) => {
  const maxPercent = getPercentage(sentence);
  const mostEfficient = getCategory(sentence, "most");
  const leastEfficient = getCategory(sentence, "least");
  const efficientType = sentence.includes("LESS") ? "LESS" : "MORE";
  // const moreEfficientText = {
  //   left:
  //     sentence
  //       .match(/.+\d{1,3}% (more|less) efficient/gi)?.[0]
  //       .replace(/\d{1,3}% (more|less) efficient/gi, "") ?? "",
  //   percent: sentence.match(/\d{1,3}% (more|less) efficient/gi)?.[0] ?? "",
  //   right:
  //     sentence
  //       .match(/\d{1,3}% (more|less) efficient.+/gi)?.[0]
  //       .replace(/\d{1,3}% (more|less) efficient/gi, "") ?? ""
  // };

  const mostEfficientPlayer = displayType !== "players" ? getPlayer(sentence, teamPlayers, "most") : "";

  const lessEfficientPlayer = displayType !== "players" ? getPlayer(sentence, teamPlayers, "less") : "";

  const formattedText = createMarkup(getFormattedText(sentence));

  return (
    <div className="card SQDoc">
      <div className="card__chart">
        <div className="card__chart___bar">
          <div className="bar bar--green" style={{ height: `${maxPercent}%` }}></div>

          {efficientType === "LESS" ? (
            <small>
              <i>{lessEfficientPlayer}</i>
              {leastEfficient.toUpperCase()}
            </small>
          ) : (
            <small>
              <i>{mostEfficientPlayer}</i>
              {mostEfficient.toUpperCase()}
            </small>
          )}
        </div>
        <div className="card__chart___bar">
          <div className="bar bar--light"></div>
          {/* <small>
            <i>{lessEfficientPlayer}</i>
            {leastEfficient.toUpperCase()}
          </small> */}

          {efficientType === "LESS" ? (
            <small>
              <i>{mostEfficientPlayer}</i>
              {mostEfficient.toUpperCase()}
            </small>
          ) : (
            <small>
              <i>{lessEfficientPlayer}</i>
              {leastEfficient.toUpperCase()}
            </small>
          )}
        </div>
      </div>

      <div className="card__text">
        <p dangerouslySetInnerHTML={formattedText}></p>
        {/* <p>
          {moreEfficientText["left"]}
          <strong style={{ color: "green", fontWeight: "600" }}>
            {` ${moreEfficientText["percent"]} `}
          </strong>

          {moreEfficientText["right"]}
         
        </p> */}
      </div>
    </div>
  );
};

export default SQDocCard;
